import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import { Player } from '@tribeplatform/react-ui-kit';
export const PREVIEW_SUPPORTED_EXTENSION = [
    'jpg',
    'jpeg',
    'png',
    'jiff',
    'gif',
    'pdf',
    'svg',
    'mp4',
    'ogg',
    'mp3',
    'wav',
];
const containerHeight = 'calc(100vh - 170px)';
export const MediaPreview = ({ media, isActive, }) => {
    var _a, _b;
    const { name, url } = media;
    const extension = (_b = (_a = media) === null || _a === void 0 ? void 0 : _a.extension) === null || _b === void 0 ? void 0 : _b.toLowerCase();
    if (extension && !PREVIEW_SUPPORTED_EXTENSION.includes(extension))
        return (_jsx("div", { className: "flex h-full w-full items-center justify-center", children: _jsx("p", { children: "Preview not supported" }, void 0) }, void 0));
    if (extension === 'pdf')
        return (_jsx("iframe", { className: "rounded-b", title: name, src: url, style: {
                height: containerHeight,
            } }, void 0));
    if (['mp4', 'ogg', 'mp3', 'wav'].indexOf(extension) !== -1) {
        const isAudio = extension !== 'mp4';
        return (_jsx("div", { className: "flex items-center justify-center", style: {
                height: containerHeight,
            }, children: _jsx("div", { className: clsx('w-full max-h-full flex items-center', !isAudio ? 'aspect-video' : 'h-16'), children: _jsx(Player, { controls: true, playing: isActive, config: { file: { forceAudio: isAudio } }, muted: !isAudio, width: "100%", height: isAudio ? '50px' : '100%', style: {
                        display: 'flex',
                        width: '100%',
                    }, url: url }, void 0) }, void 0) }, void 0));
    }
    return (_jsx("div", { className: "flex items-center justify-center", style: {
            height: containerHeight,
        }, children: _jsx("img", { src: url, className: "object-contain max-h-full", alt: name, loading: "lazy" }, void 0) }, void 0));
};
//# sourceMappingURL=MediaPreview.js.map